<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_22289_26605)">
<path d="M3.9 4.08496H20.1C20.3387 4.08496 20.5676 4.17978 20.7364 4.34856C20.9052 4.51735 21 4.74627 21 4.98496V19.385C21 19.6237 20.9052 19.8526 20.7364 20.0214C20.5676 20.1901 20.3387 20.285 20.1 20.285H3.9C3.66131 20.285 3.43239 20.1901 3.2636 20.0214C3.09482 19.8526 3 19.6237 3 19.385V4.98496C3 4.74627 3.09482 4.51735 3.2636 4.34856C3.43239 4.17978 3.66131 4.08496 3.9 4.08496ZM19.2 7.89916L12.0648 14.2892L4.8 7.87936V18.485H19.2V7.89916ZM5.2599 5.88496L12.0549 11.8808L18.7518 5.88496H5.2599Z" fill="#0F9129"/>
</g>
<defs>
<clipPath id="clip0_22289_26605">
<rect width="24" height="24" fill="white" transform="translate(0 0.18457)"/>
</clipPath>
</defs>
</svg>
